import { Event } from '../Event'
import { Identity } from '../../constants'

export class QuickReplyUsedEvent extends Event {
  static displayName = 'Quick Reply Used'

  static allowedIdentities = [Identity.BusinessUser]
}
